import * as React from "react";
import { PrimaryButton } from "../../../Base/Buttons";
import { constants } from "../../../../../store/invoicingCustomer";
import { useFormInstanceField } from "../../../../../store/base";
import ToolTip from "../../../../ToolTip/ToolTip";

export default ({ onSubmit }) => {
  const [showWarning, setShowWarning] = React.useState(false);
  const storeName = constants.STORE_NAME;

  const hasSettingSelected = useFormInstanceField({
    storeName,
    fieldKey: "setting",
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        minHeight: 200,
      }}
      onMouseOver={() => setShowWarning(true)}
      onMouseLeave={() => setShowWarning(false)}
    >
      <div>
        <PrimaryButton
          disabled={!hasSettingSelected}
          title="Spara och gå vidare till kostnader"
          clicked={onSubmit}
        />
      </div>
      {!hasSettingSelected && showWarning && (
        <ToolTip
          title="Ingen inställning vald"
          content="Välj inställning för att gå vidare"
        />
      )}
    </div>
  );
};
